/** Canonical site origin (non-www) — keep consistent across SEO and share links. */
export const SITE_CANONICAL_ORIGIN = "https://valorantcrosshair.com";

/**
 * 1200x630 PNG — not the 1024x1024 WebP that used to be here. Several social scrapers
 * do not decode WebP, and `summary_large_image` centre-crops a square.
 * Regenerate with `node scripts/make-og-image.mjs`.
 */
export const DEFAULT_OG_IMAGE = `${SITE_CANONICAL_ORIGIN}/valorantcrosshair-og.png`;

export const DEFAULT_SITE_NAME = "ValorantCrosshair.com";
